import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const StyledFooter = styled.footer`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0;
`;

export const FooterContainer = styled.div`
  background-color: white;
  width: 100%;
  overflow: hidden;
  padding: 60px 48px 12px;
  box-sizing: border-box;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    padding-bottom: 22px;
  }
`;

export const TopDivider = styled.div`
  border-top: 1px solid rgba(29, 29, 29, 0.1);
  min-height: 1px;
  width: 100%;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 100px;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-top: 40px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    flex-wrap: wrap;
    gap: 40px;
  }
`;

export const LeftSection = styled.div`
  color: #1d1d1d;
  flex-grow: 1;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    max-width: 100%;
  }
`;

export const LogoAndDescription = styled.div`
  min-height: 130px;
  max-width: 516px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5em;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const FooterLogoLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
`;

export const FooterLogo = styled.img`
  object-fit: contain;
  height: 38px;
  width: 144px;
  max-width: 100%;
`;

export const DescriptionText = styled.div`
  flex: 1;
  margin-top: 18px;

  font-weight: 400;
  font-size: 16px;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.5);

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }
`;

export const ContactSection = styled.div`
  width: 100%;
  margin-top: 69px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    margin-top: 40px;
  }
`;

export const ContactPrompt = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.85);

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }
`;

export const EmailLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 64px;
  font-weight: 500;
  white-space: nowrap;
  letter-spacing: -0.02em;
  line-height: 1.2em;
  flex-wrap: wrap;
  margin-top: 4px;

  @media (max-width: 1410px) {
    font-size: 3.5vi;
  }

  @media (max-width: 1280px) {
    font-size: 2.5vi;
  }

  @media (max-width: 835px) {
    font-size: 2.1vi;
  }

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    font-size: 24px;
    letter-spacing: unset;
    line-height: 1.3em;
    white-space: normal;
  }
`;

export const EmailLink = styled.a`
  align-self: stretch;
  margin: auto 0;
  color: rgba(29, 29, 29, 0.85);
  text-decoration: none;
  transition: color 0.2s ease;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }

  &:hover {
    color: rgba(255, 96, 48, 1);
  }
`;

export const EmailIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  width: 64px;
  align-self: stretch;
  flex-shrink: 0;
  margin: auto 0;

  @media (max-width: 1410px) {
    width: 3.5vi;
  }

  @media (max-width: 1280px) {
    width: 2.5vi;
  }

  @media ${({ theme }) => theme.media.mobile} {
    width: 28px;
  }
`;

export const RightSection = styled.div`
  display: flex;
  gap: 82px;
  justify-content: space-between;

  @media (max-width: 468px) {
    width: 100%;
    gap: 52px;
  }
`;

export const QuickLinksNav = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  font-size: 16px;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.85);
  font-weight: 500;
`;

export const FooterNavLink = styled.a`
  align-self: stretch;
  width: 100%;
  white-space: nowrap;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  transition: color 0.2s ease;

  &:hover {
    color: rgba(255, 96, 48, 1);
  }

  ${({ $isDisabled }) =>
    !!$isDisabled &&
    css`
      pointer-events: none;
      cursor: default;
    `}
`;

export const ContactAndSocials = styled.div`
  display: flex;
  min-height: 226px;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-width: 180px;
  gap: 86px;

  @media ${({ theme }) => theme.media.mobile} {
    justify-content: space-between;
    gap: 40px;
  }
`;

export const ContactInfo = styled.div`
  width: 100%;
  font-size: 16px;
  line-height: 1.5em;
  color: #1d1d1d;
`;

export const ContactUsLink = styled(FooterNavLink)`
  font-weight: 500;
  color: rgba(29, 29, 29, 0.85);
  display: block;

  ${({ $isDisabled }) =>
    !!$isDisabled &&
    css`
      pointer-events: none;
      cursor: default;
    `}
`;

export const Address = styled.div`
  align-self: stretch;
  flex: 1 1 0%;
  width: 100%;
  font-weight: 400;
  padding-top: 8px;
  padding-bottom: 8px;
  font-style: normal;
  color: rgba(29, 29, 29, 0.5);
`;

export const BottomSection = styled.div`
  width: 100%;
  font-size: 16px;
  line-height: 1.5em;
  color: #1d1d1d;
  font-weight: 500;
  margin-top: 40px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }
`;

export const BottomDivider = styled(TopDivider)`
  /* Inherits styles from TopDivider */
`;

export const BottomLinksWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 100px;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 12px;

  @media ${({ theme }) => theme.media.mobile} {
    margin-top: 20px;
    max-width: 100%;
    gap: 16px;
  }
`;

export const CopyrightText = styled.div`
  align-self: stretch;
  margin: auto 0;
  padding-top: 8px;
  padding-bottom: 8px;
  color: rgba(29, 29, 29, 0.5);
`;

export const LegalLinks = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  margin: auto 0;
  column-gap: 32px;

  @media ${({ theme }) => theme.media.mobile} {
    column-gap: 80px;
    flex-wrap: wrap;
  }
`;

export const LegalLink = styled.a`
  align-self: stretch;
  margin: auto 0;
  padding: 8px 0;
  border-radius: 12px;
  white-space: nowrap;
  text-decoration: none;
  color: rgba(29, 29, 29, 0.85);
  transition: color 0.2s ease;

  &:hover {
    color: rgba(255, 96, 48, 1);
  }
`;
